module.exports = __webpack_public_path__ + "static/media/lodestar-bg.375e9541.png";